import {useRouting} from '@/composables/use-routing.js'

/**
 * Navigation helpers for moving across the app
 */
export function useNavigation() {

  //Routing
  const {pushRoute, withParams, withQuery} = useRouting()

  //Home
  const goToHome = (...args) => pushRoute('home', ...args)

  //Enrollments
  const goToEnroll = (...args) => pushRoute('enroll', ...args)
  const goToManageEnrollment = (enrollmentId, ...args) => pushRoute(
    withParams('manage-enrollment', {enrollmentId}), ...args
  )

  //Conversation views for channel/enrollment
  // Optional second param is a messageId (query param).
  // Optional remaining args are forwarded to pushRoute (e.g. click event).
  const goToConversationForChannelId = (channelId, messageId, ...args) => pushRoute(
    withQuery(
      withParams('conversation.channel', {channelId}),
      messageId ? {messageId} : {}
    ),
    ...args
  )
  const goToConversationForEnrollmentId = (enrollmentId, messageId, ...args) => pushRoute(
    withQuery(
      withParams('conversation.enrollment', {enrollmentId}),
      messageId ? {messageId} : {}
    ),
    ...args
  )

  //Helper to navigate to conversation view for a channel or enrollment model
  const goToConversationForChannel = channel => {
    goToConversationForChannelId(channel.id)
  }
  const goToConversationForEnrollment = enrollment => {
    if (enrollment.hasChannel) {
      goToConversationForChannelId(enrollment.channel.id)
    }
    else {
      goToConversationForEnrollmentId(enrollment.id)
    }
  }

  //Follow deep link provided by Teams
  const followTeamsDeepLink = deepLink => {
    const [path, queryString] = String(deepLink || '').split('?')
    const queryParams = new URLSearchParams(queryString || '')
    const messageId = queryParams.get('messageId')

    //Enrollment management (backwards compatibility)
    if (path === 'manage-enrollments' || path === 'enrollments-overview' || path === 'home') {
      goToHome()
    }

    //Differentiate between enrollment and channel deep links
    else if (path.startsWith('channel/')) {
      const channelId = path.split('/')[1]
      goToConversationForChannelId(channelId, messageId)
    }
    else if (path.startsWith('enrollment/')) {
      const enrollmentId = path.split('/')[1]
      goToConversationForEnrollmentId(enrollmentId, messageId)
    }

    //Fall back to enrollment view (v2)
    else {
      goToConversationForEnrollmentId(path, messageId)
    }
  }

  //Expose interface
  return {

    //Home
    goToHome,

    //Enrollments
    goToEnroll,
    goToManageEnrollment,

    //Conversation views
    goToConversationForChannelId,
    goToConversationForEnrollmentId,
    goToConversationForChannel,
    goToConversationForEnrollment,

    //Teams deep link helper
    followTeamsDeepLink,
  }
}
